import { Faq } from "@cryptors/api-client";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { IResourceComponentsProps } from "@refinedev/core";
import { List, ShowButton, EditButton, useDataGrid } from "@refinedev/mui";
import React, { useMemo } from "react";

import { DeleteIconButton } from "@/components/forms/DeleteIconButton";
import { getTranslation } from "@/utils/translation";

interface FaqRow {
  id: number;
  name?: string;
}

export const FaqList: React.FC<IResourceComponentsProps> = () => {
  const { dataGridProps } = useDataGrid<Faq>({
    resource: "faq",
    pagination: { pageSize: 25 },
    sorters: { initial: [{ field: "id", order: "asc" }] },
  });

  const rows = useMemo(
    () =>
      (dataGridProps.rows as Faq[]).map((faq) => ({
        id: faq.id,
        name: getTranslation(faq.nameTranslation)?.value,
      })),
    [dataGridProps.rows],
  );

  const columns = useMemo<GridColDef<FaqRow>[]>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
      },
      {
        field: "name",
        flex: 1,
        headerName: "Nom",
        sortable: false,
        minWidth: 200,
      },
      {
        field: "action",
        headerName: "Actions",
        minWidth: 160,
        sortable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (record) => {
          return (
            <>
              <EditButton hideText recordItemId={record.id} />
              <ShowButton hideText recordItemId={record.id} />
              <DeleteIconButton recordItemId={record.id} />
            </>
          );
        },
      },
    ],
    [],
  );

  return (
    <List title="FAQ">
      <DataGrid
        {...dataGridProps}
        rows={rows}
        columns={columns}
        autoHeight
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        pageSizeOptions={[10, 25, 50, 100]}
      />
    </List>
  );
};
